module.exports = __webpack_public_path__ + "img/overview_brand_03.9b0849a9.jpg";